import update from 'immutability-helper'

const initialState = {
	categories: {},
	isLoading: 0,
	hasError: 0
}

export default (state = initialState, action) => {
	switch (action.type){
		case 'CATEGORIES_ARE_LOADING':
			return {
				...initialState,
				isLoading: 1
			}
		case 'CATEGORIES_HAS_ERROR':
			return {
				...state,
				isLoading: 0,
				hasError: 1
			}
		case 'CATEGORIES_SUCCESS':
			return {
				...state,
				...action.data.data,
				isLoading: 0
			}
		case 'CATEGORY_UNLOAD':
			return initialState

		case 'CATEGORY_SORT':
			return {
				...state,
				categories: update(state.categories, {
					[action.index]: { results: { items: { $set: action.sortedItems } } }
				})
			}

		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/store/reducers/category.js